import { mapGetters, mapActions } from 'vuex';
import store from './store';

export default {
  created() {
    store.install(this.$store);
  },
  mounted() {
    if (!this.beansList.length) {
      this.fetchBeansList();
    }
  },
  computed: {
    ...mapGetters('beans', ['beansList']),
  },
  methods: {
    ...mapActions('beans', ['fetchBeansList']),
    getBeanName(value) {
      let item = this.beansList.find(area => area.value === value);
      if (item) {
        return item.name;
      } else {
        return '';
      }
    },
  },
};
